import React from 'react'
import about from "../images/About us.jpeg";
import ReadMore from './ReadMore';
function Aboutus() {
    return (
        <div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            
                                <div className="card-body">
                                    <h1 style={{color:"#060763"}} className="card-title"><b>About us</b></h1>
                                    <p  style={{color:"#104A3F"}} className="card-text">Master Of Security System – Complete Protection & Tech Solutions</p>
                                    <ReadMore 
        text="At Master Of Security System, we provide end-to-end security and electronic solutions to keep your home, office, shop and business fully protected and smoothly running.
With our expert team based in Berhampore, Murshidabad, we deliver fast, reliable and professional service at your doorstep. Our Core Services

1. CCTV Camera Installation & Maintenance
High-quality surveillance systems with HD night vision, remote monitoring and complete setup support.

2. GPS Tracking System
Real-time vehicle tracking, route history, speed monitoring and smart alerts for cars, bikes, goods vehicles and fleets.

3. Intercom Solutions
Secure door communication systems for homes, apartments, offices and commercial buildings.

4. Audio-Video Setup
Home theatre installation, video door phones, smart audio systems, conference room AV solutions and complete wiring.

5. Sensor & Alarm System
Motion sensors, fire alarms, smoke detectors, door sensors and advanced smart alert systems.

6. Computer, Laptop & Printer Service
Full repair, upgrade, formatting, OS installation, networking and accessories support.

7. Electrical Services
Complete wiring, new electrical point setup, fault finding, repair and electrical maintenance.

All Accessories Available
CCTV, GPS, intercom, cables, DVR/NVR, power supplies, batteries, routers, switches and all essential electronic accessories."

        limit={250} // optional
      />
                                </div>
                            
                        </div>
                         <div className="col-md-6">
                          
                                <img src={about} className="card-img-top" alt="about" />
                                
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aboutus